import { TrendingDown } from "lucide-react";

export default function CostBenefitChart({ data }) {
  const max = 100;
  return (
    <div data-testid="cost-benefit-chart" className="border border-border bg-card">
      <div className="p-8 md:p-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div className="max-w-2xl">
            <div className="kicker text-flame mb-3">Cost-Benefit Analysis</div>
            <h2 className="font-display font-extrabold text-2xl md:text-3xl text-ink tracking-tight">Lower total cost of ownership</h2>
            <p className="mt-3 text-muted-foreground leading-relaxed">{data.intro}</p>
          </div>
          <div className="flex items-center gap-3 bg-flame/10 border border-flame/30 px-5 py-4 flex-shrink-0">
            <TrendingDown className="h-7 w-7 text-flame flex-shrink-0" />
            <div>
              <div className="font-display font-extrabold text-lg text-ink leading-tight">{data.savingsHeadline}</div>
              <div className="text-xs text-muted-foreground">vs. the conventional approach</div>
            </div>
          </div>
        </div>

        {/* Legend */}
        <div className="mt-8 flex flex-wrap items-center gap-6">
          <div className="flex items-center gap-2">
            <span className="inline-block h-3 w-3" style={{ background: "#9CA3AF" }} />
            <span className="text-xs font-semibold text-charcoal uppercase tracking-wide">{data.conventionalLabel}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="inline-block h-3 w-3" style={{ background: "#FF4500" }} />
            <span className="text-xs font-semibold text-charcoal uppercase tracking-wide">{data.productLabel}</span>
          </div>
        </div>

        {/* Bars */}
        <div className="mt-6 space-y-6">
          {data.metrics.map((m) => (
            <div key={m.label} data-testid={`cb-metric-${m.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-charcoal">{m.label}</span>
              </div>
              <div className="space-y-1.5">
                <div className="flex items-center gap-3">
                  <div className="flex-1 h-6 bg-muted relative overflow-hidden">
                    <div className="h-full flex items-center justify-end pr-2 transition-all duration-700" style={{ width: `${(m.conventional / max) * 100}%`, background: "#9CA3AF" }}>
                      <span className="text-[11px] font-mono font-semibold text-white">{m.conventional}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex-1 h-6 bg-muted relative overflow-hidden">
                    <div className="h-full flex items-center justify-end pr-2 transition-all duration-700" style={{ width: `${(m.oneharvest / max) * 100}%`, background: "#FF4500" }}>
                      <span className="text-[11px] font-mono font-semibold text-white">{m.oneharvest}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex items-center justify-between flex-wrap gap-2 border-t border-border pt-4">
          <span className="text-xs text-muted-foreground">Relative cost index — lower is better (conventional baseline = 100).</span>
          <span className="text-[11px] text-muted-foreground italic">{data.disclaimer}</span>
        </div>
      </div>
    </div>
  );
}
